import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Messages } from '../../model/constants/messages';
import { initialUiState, UiState } from '../../model/ui-state';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public status: BehaviorSubject<UiState> = new BehaviorSubject(initialUiState);

  constructor() {
  }

  startBackendAction(message: string = Messages.STANDARD_SPINNER_MESSAGE) {
    this.status.next({
      actionOngoing: true,
      message
    });
  }

  endBackendAction() {
    this.status.next({
      actionOngoing: false,
      message: ''
    });
  }
}
